import React from 'react';
import ClientCancelDocumentsTable from '~/components/ClientCancelDocumentsTable';
import Collapse from '~/components/collapse';
import ContainerFlex from '~/components/containerFlex';
import { ConsultclientCancelResponse } from '~/services/consult/user/detail/response';

interface CancelledContractSectionProps {
  form: Record<string, any>;
  collapseHeight: number;
  onOpen: () => void;
  dataResponse?: ConsultclientCancelResponse;
  onClickInvoice: (invoice: ConsultclientCancelResponse['faturas'][number]) => void;
}

const CancelledContractSection: React.FC<CancelledContractSectionProps> = ({
  form,
  collapseHeight,
  onOpen,
  dataResponse,
  onClickInvoice,
}) => {
  const title = form?.temCartaoCredito
    ? form?.temCarteiraDigital
      ? '10. Doc. Contrato cancelado'
      : '9. Doc. Contrato cancelado'
    : '3. Doc. Contrato cancelado';

  return (
    <Collapse
      initialState="close"
      collapseHeight={collapseHeight}
      title={title}
      actionOnOpen={onOpen}
    >
      <ContainerFlex marginLeft={26} marginRight={26}>
        <ClientCancelDocumentsTable dataResponse={dataResponse} onClickInvoice={onClickInvoice} />
      </ContainerFlex>
    </Collapse>
  );
};

export default CancelledContractSection;
